import React from "react";
import VerifyPhone from "../onboarding/VerifyPhone";
import { useNavigate } from "react-router";

export default function MobilePhone() {
  const navigate = useNavigate();

  return (
    <div className="mt-20">
      <VerifyPhone
        afterSubmit={(phone) =>
          navigate("/home/settings/pin", {
            state: { back: true, title: "Enter Pin", phone: phone },
          })
        }
        autoFocusInput
      />
    </div>
  );
}
